import { render, staticRenderFns } from "./ChannelChart.vue?vue&type=template&id=f5bd2c74&"
import script from "./ChannelChart.vue?vue&type=script&lang=js&"
export * from "./ChannelChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports